export const formatSensorLicenses = (type: string, device_number: string) => {
  let license;
  switch (type) {
    case 'T1Y1':
      license = `PW:T1_1_${device_number.toString().padStart(6, '0')}`;
      break;
    case 'T1Y2':
      license = `PW:T1_2_${device_number.toString().padStart(6, '0')}`;
      break;
    case 'T1Y3':
      license = `PW:T1_3_${device_number.toString().padStart(6, '0')}`;
      break;
    case 'T2Y1':
      license = `PW:T2_1_${device_number.toString().padStart(6, '0')}`;
      break;
    case 'T2Y2':
      license = `PW:T2_2_${device_number.toString().padStart(6, '0')}`;
      break;
    case 'T2Y3':
      license = `PW:T2_3_${device_number.toString().padStart(6, '0')}`;
      break;
    case 'T3Y1':
      license = `PW:T3_1_${device_number.toString().padStart(6, '0')}`;
      break;
    case 'T3Y2':
      license = `PW:T3_2_${device_number.toString().padStart(6, '0')}`;
      break;
    case 'T3Y3':
      license = `PW:T3_3_${device_number.toString().padStart(6, '0')}`;
      break;
    case 'T4Y1':
      license = `PW:T4_1_${device_number.toString().padStart(6, '0')}`;
      break;
    case 'T4Y2':
      license = `PW:T4_2_${device_number.toString().padStart(6, '0')}`;
      break;
    case 'T4Y3':
      license = `PW:T4_3_${device_number.toString().padStart(6, '0')}`;
      break;
    case 'T1LF':
      license = `PW:T1_LF_${device_number.toString().padStart(6, '0')}`;
      break;
    case 'T2LF':
      license = `PW:T2_LF_${device_number.toString().padStart(6, '0')}`;
      break;
    case 'T3LF':
      license = `PW:T3_LF_${device_number.toString().padStart(6, '0')}`;
      break;
    case 'T4LF':
      license = `PW:T4_LF_${device_number.toString().padStart(6, '0')}`;
      break;
  }
  return license;
};